import { countries } from "countries-list"
import { getCountries } from "libphonenumber-js"


const priorCountries = ['SG', 'MY', 'TH', 'VN', 'HK', 'ID'] as ['SG', 'MY', 'TH', 'VN', 'HK', 'ID']
const countryCodeList: { label: string, value: string }[] = []

{
    // Initialize country list
    let country: typeof priorCountries[number]
    for (country of priorCountries) {
        countryCodeList.push({ label: countries[country].name, value: country })
    }

    const countriesList = getCountries()

    for (let isoCode of countriesList) {
        const findFn = (d: string) => d === isoCode
        if (priorCountries.findIndex(findFn) === -1) {
            const country = countries[isoCode as keyof typeof countries]
            if (country) {
                countryCodeList.push({ label: country.name, value: isoCode })
            }
        }
    }
}

export default countryCodeList